/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export type ActivityTagValue =
    | 'biking'
    | 'climbing'
    | 'education'
    | 'featured-hunt-fish'
    | 'fishing'
    | 'hiking'
    | 'horseback_riding'
    | 'hunting'
    | 'orv_ohv_atv'
    | 'paddling'
    | 'water_activities'
    | 'wildlife_viewing'
    | 'winter_sports';

export interface ActivityTagOption {
    label: string;
    value: ActivityTagValue;
}

export const ACTIVITY_TAG_OPTIONS: ActivityTagOption[] = [
    { label: 'Biking', value: 'biking' },
    { label: 'Water Activities', value: 'water_activities' },
    { label: 'Hiking', value: 'hiking' },
    { label: 'Fishing', value: 'fishing' },
    // { label: 'Hunting', value: 'hunting' },
    { label: 'Wildlife Viewing', value: 'wildlife_viewing' },
    { label: 'Education / Programs', value: 'education' },
    // { label: 'Climbing', value: 'climbing' },
    // { label: 'Horseback Riding', value: 'horseback_riding' },
    // { label: 'Off-Roading', value: 'orv_ohv_atv' },
    // { label: 'Paddling', value: 'paddling' },
    // { label: 'Winter Sports', value: 'winter_sports' },
];

export const ALL_ACTIVITY_TAGS: ActivityTagOption[] = [
    ...ACTIVITY_TAG_OPTIONS,
    // `featured-hunt-fish` is intentionally excluded from ACTIVITY_TAG_OPTIONS (the UI
    // dropdown) because it is a URL-only special case (?activity_tags=featured-hunt-fish).
    // It is included here so ACTIVITY_TAG_LABEL_MAP can resolve its display label.
    { label: 'Featured Hunting & Fishing', value: 'featured-hunt-fish' },
];

export const ACTIVITY_TAG_LABEL_MAP: Record<string, string> = Object.fromEntries(
    ALL_ACTIVITY_TAGS.map((t) => [t.value, t.label])
);

// cSpell:ignore horseback, off-roading
